import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const storeBrandList = (data) => {
	return {
		type: Types.STORE_BRAND_LIST,
		payload: data
	};
};

export const fetchBrandList =
	(params = '?page=0&size=1000') =>
	async (dispatch) => {
		await ApiClient.GET('getBrandBasicList', params).then((response) => {
			dispatch(storeBrandList(response.data.data));
		});
	};
